import * as React from "react"

export type Locale = "en" | "fr" | "zh"

const messages = {
  en: {
    buy: "Buy",
    rent: "Rent",
    sell: "Sell",
    properties: "Properties",
    openHouses: "Open houses",
    notes: "Field notes",
    signIn: "Sign in",
    dashboard: "Dashboard",
    search: "Search",
    menu: "Menu",
    lookingTo: "Looking to",
    buyOrRent: "Buy or rent",
    propertyType: "Property type",
    everyType: "Every type",
    region: "Region",
    everyRegion: "Every region",
    keywords: "Keywords",
    keywordsPlaceholder: "Garden, studio, water…",
    refineField: "Refine the field",
    listingReference: "Listing reference",
    locality: "Locality",
    neighborhood: "Neighborhood",
    minimumPrice: "Minimum price",
    maximumPrice: "Maximum price",
    minimumBedrooms: "Minimum bedrooms",
    minimumBathrooms: "Minimum bathrooms",
    minimumInterior: "Minimum interior m²",
    minimumLand: "Minimum land m²",
    sortBy: "Sort by",
    newestFirst: "Newest first",
    priceLowHigh: "Price: low to high",
    priceHighLow: "Price: high to low",
    nearTown: "Near town center",
    waterfront: "Waterfront",
    residential: "Residential",
    commercial: "Commercial",
    land: "Land",
    investment: "Investment",
    holidayRental: "Holiday rental",
    searchListings: "Search listings",
    cataloguePropertyFinder: "Catalogue · property finder",
    propertySearch: "Property search",
    listing: "listing",
    listings: "listings",
    matchSearchSingular: "matches your search.",
    matchSearch: "match your search.",
    saveSearch: "Save search",
    listOnly: "List only",
    showMap: "Show map",
    refineSearch: "Refine the search",
    clearFilters: "Clear filters",
    noListingsFound: "No listings match your search",
    widenCriteria: "Widen the price, location, or property-type criteria.",
    previous: "Previous",
    next: "Next",
    page: "Page",
    nameSearch: "Name this search",
    saveSearchDescription:
      "Keep the active filters so you can reopen or attach alerts later.",
    savedSearchName: "Saved search name",
    saving: "Saving…",
    saveSearchAction: "Save search",
  },
  fr: {
    buy: "Acheter",
    rent: "Louer",
    sell: "Vendre",
    properties: "Propriétés",
    openHouses: "Visites libres",
    notes: "Carnet de terrain",
    signIn: "Connexion",
    dashboard: "Tableau de bord",
    search: "Rechercher",
    menu: "Menu",
    lookingTo: "Votre projet",
    buyOrRent: "Acheter ou louer",
    propertyType: "Type de bien",
    everyType: "Tous les types",
    region: "Région",
    everyRegion: "Toutes les régions",
    keywords: "Mots-clés",
    keywordsPlaceholder: "Jardin, studio, eau…",
    refineField: "Affiner la recherche",
    listingReference: "Référence de l’annonce",
    locality: "Localité",
    neighborhood: "Quartier",
    minimumPrice: "Prix minimum",
    maximumPrice: "Prix maximum",
    minimumBedrooms: "Chambres minimum",
    minimumBathrooms: "Salles de bains minimum",
    minimumInterior: "Surface intérieure min. m²",
    minimumLand: "Terrain minimum m²",
    sortBy: "Trier par",
    newestFirst: "Plus récentes",
    priceLowHigh: "Prix : croissant",
    priceHighLow: "Prix : décroissant",
    nearTown: "Près du centre",
    waterfront: "Bord de l’eau",
    residential: "Résidentiel",
    commercial: "Commercial",
    land: "Terrain",
    investment: "Investissement",
    holidayRental: "Location de vacances",
    searchListings: "Rechercher des biens",
    cataloguePropertyFinder: "Catalogue · recherche de biens",
    propertySearch: "Recherche de biens",
    listing: "bien",
    listings: "biens",
    matchSearchSingular: "correspond à votre recherche.",
    matchSearch: "correspondent à votre recherche.",
    saveSearch: "Enregistrer",
    listOnly: "Liste seule",
    showMap: "Afficher la carte",
    refineSearch: "Affiner la recherche",
    clearFilters: "Effacer les filtres",
    noListingsFound: "Aucun bien ne correspond",
    widenCriteria: "Élargissez les critères de prix, de lieu ou de type.",
    previous: "Précédent",
    next: "Suivant",
    page: "Page",
    nameSearch: "Nommer cette recherche",
    saveSearchDescription:
      "Conservez les filtres actifs pour rouvrir la recherche ou ajouter des alertes.",
    savedSearchName: "Nom de la recherche",
    saving: "Enregistrement…",
    saveSearchAction: "Enregistrer la recherche",
  },
  zh: {
    buy: "购买",
    rent: "租赁",
    sell: "出售",
    properties: "房源",
    openHouses: "开放看房",
    notes: "市场笔记",
    signIn: "登录",
    dashboard: "控制面板",
    search: "搜索",
    menu: "菜单",
    lookingTo: "您的需求",
    buyOrRent: "购买或租赁",
    propertyType: "房产类型",
    everyType: "全部类型",
    region: "区域",
    everyRegion: "全部区域",
    keywords: "关键词",
    keywordsPlaceholder: "花园、工作室、水景…",
    refineField: "细化条件",
    listingReference: "房源编号",
    locality: "地段",
    neighborhood: "街区",
    minimumPrice: "最低价格",
    maximumPrice: "最高价格",
    minimumBedrooms: "最少卧室",
    minimumBathrooms: "最少浴室",
    minimumInterior: "最小室内面积 m²",
    minimumLand: "最小土地面积 m²",
    sortBy: "排序方式",
    newestFirst: "最新优先",
    priceLowHigh: "价格：从低到高",
    priceHighLow: "价格：从高到低",
    nearTown: "靠近市中心",
    waterfront: "滨水",
    residential: "住宅",
    commercial: "商业",
    land: "土地",
    investment: "投资",
    holidayRental: "度假租赁",
    searchListings: "搜索房源",
    cataloguePropertyFinder: "房源目录 · 房产搜索",
    propertySearch: "房产搜索",
    listing: "套房源",
    listings: "套房源",
    matchSearchSingular: "符合您的搜索条件。",
    matchSearch: "符合您的搜索条件。",
    saveSearch: "保存搜索",
    listOnly: "仅显示列表",
    showMap: "显示地图",
    refineSearch: "调整搜索条件",
    clearFilters: "清除筛选条件",
    noListingsFound: "没有符合条件的房源",
    widenCriteria: "请放宽价格、位置或房产类型条件。",
    previous: "上一页",
    next: "下一页",
    page: "页",
    nameSearch: "为搜索命名",
    saveSearchDescription: "保存当前筛选条件，以便稍后重新打开或添加提醒。",
    savedSearchName: "已保存的搜索名称",
    saving: "正在保存…",
    saveSearchAction: "保存搜索",
  },
} as const

type MessageKey = keyof (typeof messages)["en"]

type LocaleContextValue = {
  locale: Locale
  setLocale: (locale: Locale) => void
  t: (key: MessageKey) => string
}

const LocaleContext = React.createContext<LocaleContextValue | null>(null)

export function LocaleProvider({
  initialLocale,
  children,
}: {
  initialLocale?: Locale
  children: React.ReactNode
}) {
  const [locale, setLocaleState] = React.useState<Locale>(initialLocale ?? "en")

  React.useEffect(() => {
    const stored = window.localStorage.getItem("harbor-pine-locale")
    const selected =
      stored === "en" || stored === "fr" || stored === "zh"
        ? stored
        : (initialLocale ?? "en")
    setLocaleState(selected)
    document.documentElement.lang = selected === "zh" ? "zh-Hans" : selected
  }, [initialLocale])

  const setLocale = React.useCallback((value: Locale) => {
    setLocaleState(value)
    window.localStorage.setItem("harbor-pine-locale", value)
    document.documentElement.lang = value === "zh" ? "zh-Hans" : value
  }, [])

  const value = React.useMemo<LocaleContextValue>(
    () => ({
      locale,
      setLocale,
      t: (key) => messages[locale][key],
    }),
    [locale, setLocale]
  )

  return (
    <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
  )
}

export function useLocale() {
  const value = React.useContext(LocaleContext)
  if (!value) {
    throw new Error("useLocale must be used inside LocaleProvider.")
  }
  return value
}
